package uz.ferro.erp.ui.table

import mui.icons.material.Edit
import mui.material.BaseSize
import mui.material.Box
import mui.material.IconButton
import mui.material.Table
import mui.material.TableBody
import mui.material.TableCell
import mui.material.TableHead
import mui.material.TableRow
import mui.system.PropsWithSx
import mui.system.sx
import react.FC
import react.PropsWithChildren
import react.useState
import uz.ferro.erp.Colors
import web.cssom.FontSize
import web.cssom.Position
import web.cssom.TextAlign
import web.cssom.Visibility
import web.cssom.WhiteSpace
import web.cssom.px

external interface TableProps : PropsWithChildren, PropsWithSx {
    var headers: List<HeaderItem>
    var items: List<RowItem>
    var enableRowEdit: Boolean
    var onEditClick: (String) -> Unit
    var positionAutoHeight: Boolean?
    var fontSize: FontSize?
    var size: BaseSize?
}

val TableView = FC<TableProps> { props ->
    var hoveredItemKey by useState { "" }
    Table {
        sx {
            if (props.positionAutoHeight != true) {
                position = Position.absolute
                top = 0.px
                right = 0.px
                bottom = 0.px
                left = 0.px
            }
        }

        if (props.size != null) {
            size = props.size
        }

        if (props.positionAutoHeight != true) {
            stickyHeader = true
        }
        TableHead {
            TableRow {
                props.headers.forEach { headerItem ->
                    TableCell {
                        sx {
                            if (headerItem.width != null) {
                                width = headerItem.width
                            }

                            if (props.fontSize != null) {
                                fontSize = props.fontSize
                            }
                        }

                        +headerItem.title
                    }
                }
            }
        }
        TableBody {
            props.items.forEach { item ->
                TableRow {
                    hover = true
                    key = item.key
                    sx {
                        if (item.backgroundColor != null) {
                            backgroundColor = item.backgroundColor
                        }
                    }

                    onMouseOver = {
                        hoveredItemKey = item.key
                    }

                    onMouseOut = {
                        if (hoveredItemKey == item.key) {
                            hoveredItemKey = ""
                        }
                    }

                    if (item.onItemClick != null) {
                        onClick = { evt ->
                            evt.preventDefault()
                            item.onItemClick.invoke()
                        }
                    }

                    if (item.onContextMenu != null) {
                        onContextMenu = { event ->
                            event.preventDefault()
                            event.stopPropagation()
                            item.onContextMenu.invoke(
                                event.clientX.toInt(),
                                event.clientY.toInt()
                            )
                        }
                    }

                    item.cells.forEach { cell ->
                        TableCell {
                            sx {
                                textAlign = cell.textAlign
                                if (props.fontSize != null) {
                                    fontSize = props.fontSize
                                }
                            }
                            if (cell.content != null) {
                                +cell.content
                            } else {
                                if (cell.textBackgroundColor != null) {
                                    Box {
                                        sx {
                                            borderRadius = 8.px
                                            backgroundColor = cell.textBackgroundColor
                                            paddingTop = 8.px
                                            paddingBottom = 8.px
                                            paddingLeft = 12.px
                                            paddingRight = 12.px
                                            color = Colors.white
                                            textAlign = TextAlign.center
                                            whiteSpace = WhiteSpace.nowrap
                                        }
                                        +cell.title.orEmpty()
                                    }
                                } else {
                                    +cell.title.orEmpty()
                                }
                            }
                        }
                    }

                    if (props.enableRowEdit) {
                        TableCell {
                            +""
                        }
                    }

                    if (props.enableRowEdit) {
                        TableCell {
                            Box {
                                IconButton {
                                    sx {
                                        padding = 0.px
                                        visibility = if (hoveredItemKey == item.key) {
                                            Visibility.visible
                                        } else {
                                            Visibility.hidden
                                        }
                                    }
                                    Edit {
                                        htmlColor = Colors.iconSecondary
                                    }
                                    onClick = {
                                        props.onEditClick(item.key)
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
